<template>
  <div>
    <NavTabsSwiper
      :tabs-list="tabsConsignmentList"
      :is-loading="isLoadingConsignmentList"
      mobile-in-select
      show-count-in-select
    />

    <router-view />
  </div>
</template>

<script>
import NavTabsSwiper from '@/shared/ui/tabs/NavTabsSwiper.vue'
import { mapGetters, mapState } from 'vuex'

export default {
  components: {
    NavTabsSwiper
  },

  computed: {
    ...mapGetters('tabsOrderList', ['tabsConsignmentList']),

    ...mapState('consignment', ['isLoadingConsignmentList'])
  }
}
</script>
